import { clientState } from '../services/clientState';
// audit-safety-integrated
import React, { useEffect, useState } from "react";
import axios from "axios";
import { ListChecks } from "lucide-react";
import { API_BASE_URL } from '../services/api';

const ItemSelection = () => {
  const [items, setItems] = useState([]);
  const [activeTab, setActiveTab] = useState("grocery");
  const [loading, setLoading] = useState(true);

  // ✅ Store code from API response
  const [storeCode, setStoreCode] = useState(null);
  const [userBranch, setUserBranch] = useState(null);

  // Store info popup states
  const [showStoreInfoPopup, setShowStoreInfoPopup] = useState(false);
  const [storeInfo, setStoreInfo] = useState(null);
  const [storeInfoLoading, setStoreInfoLoading] = useState(false);

  // Brand popup states
  const [showBrandPopup, setShowBrandPopup] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [selectedBrandRate, setSelectedBrandRate] = useState("");

  // POPUP STATES
  const [selectedPopupItem, setSelectedPopupItem] = useState(null);

  const openBrandPopup = (item) => {
    setSelectedPopupItem(item);
    setSelectedBrand(null);
    setShowBrandPopup(true);
  };

  const closeBrandPopup = () => {
    setShowBrandPopup(false);
    setSelectedPopupItem(null);
  };

  const getSelectedItems = () => {
    return JSON.parse(clientState.getItem("selectedItems")) || [];
  };

  const filterAlreadySelected = (list) => {
    const selectedIds = getSelectedItems();
    return list.filter((item) => !selectedIds.includes(item.id));
  };

  useEffect(() => {
    loadItems();
  }, []);

  const getRateDisplay = (brands = []) => {
    if (!brands.length) return "—";

    const rates = brands.map(b => b.rate);
    const min = Math.min(...rates);
    const max = Math.max(...rates);

    return min === max ? `${min}` : `${min} - ${max}`;
  };

  const loadItems = async () => {
    try {


      const response = await axios.get(
        `${API_BASE_URL}/item/all/list`,
        {
          headers: {  },
        }
      );

      let allItems = response.data?.data || [];
      allItems = filterAlreadySelected(allItems);

      setItems(allItems);

      // ✅ Extract store code from API response
      const userData = response.data?.user;
      if (userData?.detail) {
        setStoreCode(userData.detail.store);
        setUserBranch(userData.detail.branch);
        void 0;
        void 0;
      }

    } catch (error) {
      void 0;
      // API session expiration is handled centrally.
    } finally {
      setLoading(false);
    }
  };

  const handleBrandSubmit = () => {
    if (!selectedBrand) return alert("Please select a brand");

    alert(
      `Brand selected for ${selectedItem.name}: ${selectedBrand.name} (Rate: ₹${selectedBrandRate})`
    );

    setShowBrandPopup(false);
  };

  const filteredItems = items.filter((item) => {
    if (activeTab === "grocery") return item.category === "food";
    if (activeTab === "housekeeping") return item.category === "housekeeping";
    if (activeTab === "dailie") return item.category === "dailie";
    return false;
  });

  const handleStoreInfo = async () => {
    void 0;
    void 0;

    if (!storeCode) {
      alert("Store code not available");
      return;
    }

    setStoreInfoLoading(true);
    setShowStoreInfoPopup(true);
    setStoreInfo(null);

    try {


      const response = await axios.get(
        `${API_BASE_URL}/user/store/${storeCode}`,
        {
          headers: {

          },
        }
      );

      void 0;

      if (response.data && !response.data.error) {
        setStoreInfo(response.data.data || response.data);
      } else {
        alert(response.data.message || "Failed to fetch store information");
      }
    } catch (err) {
      void 0;
      alert("Network error while fetching store information");
    } finally {
      setStoreInfoLoading(false);
    }
  };

  const submitBrandSelection = async (itemId, brandData) => {
    try {


      const payload = {
        name: brandData.brand,
      };

      const url = `${API_BASE_URL}/item/branch/brand/${itemId}`;

      await axios.put(url, payload, {
        headers: {  },
      });

      alert("Brand added successfully!");

      setItems((prevItems) =>
        prevItems.map((item) =>
          item.id === itemId
            ? {
              ...item,
              brand: brandData.brand,
              rate: brandData.rate,
              brands: item.brands.map(b =>
                b.name === brandData.brand
                  ? { ...b, rate: brandData.rate, pack_size: brandData.qty, mrp: brandData.mrp }
                  : b
              ),
            }
            : item
        )
      );

      await loadItems();
      closeBrandPopup();

    } catch (err) {
      void 0;
      alert("Failed to submit brand. Try again.");
    }
  };

const getFinalRateRange = (item) => {
    const brands = item.brands || [];

    if (!brands.length) return "—";

    const getRatePerKg = (rate, packSize) => {
      if (packSize === 0) return rate;
      return rate / packSize;
    };

    if (item.branded === 0 || item.brand === null || item.brand === "" || item.brand === "-") {
      const ratesPerKg = brands.map(b => getRatePerKg(b.rate, b.pack_size));
      const min = Math.min(...ratesPerKg);
      const max = Math.max(...ratesPerKg);
      return min === max
        ? `${min.toFixed(2)}/kg`
        : `${min.toFixed(2)} - ${max.toFixed(2)}/kg`;
    }

const selectedBrandRates = brands
      .filter(b => b.name.toLowerCase() === item.brand.toLowerCase())
      .map(b => getRatePerKg(b.rate, b.pack_size));

    // if no match found, fall back to all brands rate range
    if (!selectedBrandRates.length) {
      const allRates = brands.map(b => getRatePerKg(b.rate, b.pack_size));
      const min = Math.min(...allRates);
      const max = Math.max(...allRates);
      return min === max
        ? `${min.toFixed(2)}/kg`
        : `${min.toFixed(2)} - ${max.toFixed(2)}/kg`;
    }

    if (!selectedBrandRates.length) return "—";

    const min = Math.min(...selectedBrandRates);
    const max = Math.max(...selectedBrandRates);

    return min === max
      ? `${min.toFixed(2)}/kg`
      : `${min.toFixed(2)} - ${max.toFixed(2)}/kg`;
  };
const getValidBrands = (brands = []) => {
    return brands.filter(b => b.name && b.name.trim() !== '' && b.name.toLowerCase() !== 'unknown');
  };

  const hasMultiplePacks = (item) => {
    return getValidBrands(item.brands).length > 0;
  };

  return (
    <div className="w-full px-4 py-6">

{/* Header with Store Info */}
<div className="flex items-center justify-between mb-6">
  <h2 className="text-2xl font-bold text-gray-900 flex items-center gap-2">
    <div className="w-10 h-10 bg-blue-100 rounded-xl flex items-center justify-center">
      <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
      </svg>
    </div>
    Item Selection
  </h2>

  {storeCode && (
    <div className="flex items-center gap-3 bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-xl px-4 py-3 shadow-sm">
      <div className="flex items-center gap-2">
        <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center">
          <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
          </svg>
        </div>
        <div className="flex flex-col">
          <span className="text-xs text-blue-600 font-medium uppercase tracking-wide">Delivery Store</span>
          <span className="text-sm font-bold text-gray-900">
            {userBranch || storeCode}
          </span>
        </div>
      </div>

      <button
        onClick={handleStoreInfo}
        className="flex items-center gap-2 px-3 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-all shadow-sm hover:shadow-md"
        title="View store details"
        type="button"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-4 h-4"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
            clipRule="evenodd"
          />
        </svg>
        <span className="text-sm font-medium">Info</span>
      </button>
    </div>
  )}
</div>

      {/* Tabs */}
      <div className="flex space-x-2 mb-4">
        {[
          { key: "grocery", label: "Grocery" },
          { key: "housekeeping", label: "Housekeeping" },
          { key: "dailie", label: "Veg / Meat / Dairy " },
        ].map((tab) => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={`px-3 py-2 rounded-lg text-sm font-medium ${activeTab === tab.key
              ? "bg-blue-600 text-white"
              : "bg-gray-200 text-gray-700"
              }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Table */}
      <div className="bg-white rounded-xl shadow p-4">
        {loading ? (
          <p className="text-gray-500">Loading items...</p>
        ) : filteredItems.length === 0 ? (
          <p className="text-gray-500">No items found.</p>
        ) : (
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-gray-100 text-left text-gray-700 text-sm">
                <th className="p-2 w-20">S.No</th>
                <th className="p-2">Item Name</th>
                <th className="p-2">GST</th>
                <th className="p-2">Rate</th>
                {activeTab !== "dailie" && <th className="p-2"></th>}
              </tr>
            </thead>

            <tbody>
              {filteredItems.map((item, index) => (
                <tr key={item.id} className="border-b hover:bg-gray-50 text-sm">
                  <td className="p-2">{index + 1}</td>

                  <td className="p-2">
                    <span className="font-medium">
                      {item.name} {item.indent && <span className="text-gray-500 text-sm">({item.indent})</span>}
                    </span>

                    {item.branded === 1 && item.brand && item.brand !== "-" && (
                      <span className="ml-2 px-3 py-1 bg-green-100 text-green-700 text-sm font-semibold rounded-xl">
                        {item.brand}
                      </span>
                    )}
                  </td>

                  <td className="p-2">
                    <span className="text-blue-700 font-medium">
                      {item.gst ? `${item.gst}%` : "0%"}
                    </span>
                  </td>

                  <td className="p-2">
                    <span className="text-green-700 font-medium">
                      {activeTab === "dailie"
                        ? (item.rate ? `${Number(item.rate).toFixed(2)}/kg` : "—")
                        : getFinalRateRange(item)
                      }
                    </span>
                  </td>

                  {activeTab !== "dailie" && (
                    <td className="p-2">
                      {item.branded === 1 ? (
                        <button
                          onClick={() => {
                            if (hasMultiplePacks(item)) {
                              openBrandPopup(item);
                            }
                          }}
                          className={`p-1 rounded transition
                            ${hasMultiplePacks(item)
                              ? "text-blue-600 hover:text-blue-800 cursor-pointer"
                              : "text-gray-400 cursor-not-allowed"
                            }`}
                          title={
                            hasMultiplePacks(item)
                              ? (item.brand && item.brand !== "-" ? "Update Selected Brand" : "Select Brand")
                              : "Only one pack available"
                          }
                        >
                          <ListChecks size={18} />
                        </button>
                      ) : (
                        <span className="text-gray-400 text-sm"></span>
                      )}
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* ================= STORE INFO POPUP ================= */}
      {showStoreInfoPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg w-full max-w-2xl mx-4 max-h-[80vh] overflow-hidden flex flex-col">
            <div className="bg-blue-600 text-white px-6 py-4 rounded-t-lg flex justify-between items-center">
              <h2 className="text-xl font-semibold">Store Information</h2>
              <button
                onClick={() => setShowStoreInfoPopup(false)}
                className="text-white hover:text-gray-200 transition-colors"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <div className="p-6 overflow-y-auto flex-1">
              {storeInfoLoading ? (
                <div className="text-center py-8">
                  <div className="w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto"></div>
                  <p className="mt-2 text-gray-600">Loading store information...</p>
                </div>
              ) : storeInfo ? (
                <div className="space-y-6">
                  {/* Store Header */}
                  <div className="bg-blue-50 rounded-lg p-4 border border-blue-200">
                    <h3 className="text-lg font-bold text-blue-900">{storeInfo.name || 'N/A'}</h3>
                    <p className="text-sm text-blue-700 mt-1">{storeInfo.brand || 'N/A'}</p>
                  </div>

                  {/* Store Details Grid */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="bg-gray-50 rounded-lg p-3 border border-gray-200">
                      <p className="text-xs text-gray-500 uppercase tracking-wide mb-1">Store Code</p>
                      <p className="font-semibold text-gray-800">{storeInfo.code || 'N/A'}</p>
                    </div>

                    <div className="bg-gray-50 rounded-lg p-3 border border-gray-200">
                      <p className="text-xs text-gray-500 uppercase tracking-wide mb-1">Store Type</p>
                      <p className="font-semibold text-gray-800">{storeInfo.type || 'N/A'}</p>
                    </div>

                    <div className="bg-gray-50 rounded-lg p-3 border border-gray-200">
                      <p className="text-xs text-gray-500 uppercase tracking-wide mb-1">Store</p>
                      <p className="font-semibold text-gray-800">{storeInfo.store || 'N/A'}</p>
                    </div>

                    <div className="bg-gray-50 rounded-lg p-3 border border-gray-200">
                      <p className="text-xs text-gray-500 uppercase tracking-wide mb-1">District</p>
                      <p className="font-semibold text-gray-800">{storeInfo.district || 'N/A'}</p>
                    </div>

                    <div className="bg-gray-50 rounded-lg p-3 border border-gray-200">
                      <p className="text-xs text-gray-500 uppercase tracking-wide mb-1">Manager</p>
                      <p className="font-semibold text-gray-800">{storeInfo.manager || 'N/A'}</p>
                    </div>

                    <div className="bg-gray-50 rounded-lg p-3 border border-gray-200">
                      <p className="text-xs text-gray-500 uppercase tracking-wide mb-1">Contact</p>
                      <p className="font-semibold text-gray-800">{storeInfo.contact || 'N/A'}</p>
                    </div>

                    <div className="bg-gray-50 rounded-lg p-3 border border-gray-200">
                      <p className="text-xs text-gray-500 uppercase tracking-wide mb-1">Registration No</p>
                      <p className="font-semibold text-gray-800">{storeInfo.rno || 'N/A'}</p>
                    </div>

                    <div className="bg-gray-50 rounded-lg p-3 border border-gray-200">
                      <p className="text-xs text-gray-500 uppercase tracking-wide mb-1">Office Code</p>
                      <p className="font-semibold text-gray-800">{storeInfo.o_code || 'N/A'}</p>
                    </div>
                  </div>

                  {/* Address Section */}
                  <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                    <p className="text-xs text-gray-500 uppercase tracking-wide mb-2">Address</p>
                    <p className="font-medium text-gray-800 leading-relaxed">{storeInfo.address || 'N/A'}</p>
                  </div>

                  {/* Location Map Link */}
                  {storeInfo.location && (
                    <div className="flex justify-center">
                      <button
                        onClick={() => window.open(`https://www.google.com/maps?q=${storeInfo.location}`, '_blank')}
                        className="flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
                      >
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                        View on Google Maps
                      </button>
                    </div>
                  )}
                </div>
              ) : (
                <p className="text-center text-gray-500 py-8">No store information available</p>
              )}
            </div>

            <div className="border-t px-6 py-4 flex justify-end bg-gray-50">
              <button
                onClick={() => setShowStoreInfoPopup(false)}
                className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors shadow-sm"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Brand Popup */}
      {showBrandPopup && selectedPopupItem && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50 px-2">
          <div className="bg-white w-[600px] max-h-[85vh] overflow-y-auto rounded-xl shadow-xl animate-fadeInUp">

            {/* HEADER */}
            <div className="bg-blue-600 text-white px-5 py-3 rounded-t-xl font-semibold text-lg">
              Select Brand
            </div>

            {/* ITEM NAME */}
            <div className="px-6 py-4 text-gray-800 font-semibold text-md">
              {selectedPopupItem.name}
            </div>

            {/* BRAND LIST */}
            <div className="px-6 pb-4 space-y-3">
     {(() => {
                const validBrands = getValidBrands(selectedPopupItem.brands);

                const groupedBrands = Object.values(
                  validBrands.reduce((acc, b) => {
                    if (!acc[b.name]) {
                      acc[b.name] = { name: b.name, packs: [], rates: [] };
                    }
                    acc[b.name].packs.push(b.pack_size);
                    acc[b.name].rates.push(b.rate);
                    return acc;
                  }, {})
                );

                if (groupedBrands.length === 0) {
                  return <p className="text-gray-400 text-sm">No brands available.</p>;
                }

                return groupedBrands.map((brand, idx) => {
                  const minRate = Math.min(...brand.rates);
                  const maxRate = Math.max(...brand.rates);

                  const ratesPerKg = brand.packs.map((packSize, i) => {
                    if (packSize === 0) return brand.rates[i];
                    return brand.rates[i] / packSize;
                  });

                  const minRatePerKg = Math.min(...ratesPerKg);
                  const maxRatePerKg = Math.max(...ratesPerKg);

                  const packDisplay = brand.packs
                    .map(p => {
                      if (p === 0) return "Loose";
                      if (p < 1) return `${p * 1000} Gm`;
                      return `${p} Kg`;
                    })
                    .join(", ");

                  const rateDisplay =
                    minRatePerKg === maxRatePerKg
                      ? `${minRatePerKg.toFixed(2)}/kg`
                      : `${minRatePerKg.toFixed(2)} - ${maxRatePerKg.toFixed(2)}/kg`;

                  return (
                    <div
                      key={idx}
                      onClick={() =>
                        setSelectedBrand({
                          brand: brand.name,
                          qty: brand.packs[0],
                          rate: minRate,
                        })
                      }
                      className={`cursor-pointer rounded-lg p-4 border transition-all
                        ${selectedBrand?.brand === brand.name
                          ? "bg-blue-600 text-white border-blue-700"
                          : "bg-white text-gray-800 border-gray-300 hover:bg-blue-50"
                        }`}
                    >
                      <div className="flex justify-between items-center w-full text-md font-medium">
                        <span className="w-1/3 truncate">{brand.name}</span>
                        <span className="w-1/3 text-right">{packDisplay}</span>
                        <span className="w-1/3 text-right">{rateDisplay}</span>
                      </div>
                    </div>
                  );
                });
              })()}
            </div>

            {/* SELECTED TEXT */}
            {selectedBrand && (
              <div className="px-6 text-green-600 font-medium">
                Selected: {selectedBrand.brand}
              </div>
            )}

            {/* FOOTER BUTTONS */}
            <div className="flex justify-end gap-3 p-5 border-t">
              <button
                onClick={closeBrandPopup}
                className="px-4 py-2 rounded-lg bg-gray-200 hover:bg-gray-300"
              >
                Cancel
              </button>

              <button
                disabled={!selectedBrand}
                onClick={() => {
                  submitBrandSelection(selectedPopupItem.id, selectedBrand);
                  closeBrandPopup();
                }}
                className={`px-5 py-2 rounded-lg text-white
                  ${selectedBrand
                    ? "bg-blue-600 hover:bg-blue-700"
                    : "bg-blue-300 cursor-not-allowed"
                  }
                `}
              >
                Select
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default ItemSelection;